export default {
	SAVE_INVOICE: 'companies/:company_id/invoices/',
	GET_INVOICE: 'companies/:company_id/invoices/get-invoice/',
	MAX_INVOICE_NUMBER: 'companies/:company_id/invoices/max-invoice-number/',
	INVOICES: 'companies/:company_id/invoices/'
}
